import {Primitive} from 'utility-types';

/**
 * Recursively removes `null` and `undefined` types from an object.
 * Keeps optional properties.
 */
export type DeepNonNullableWithPartial<T> = {
  [K in keyof T]: T[K] extends Primitive
    ? NonNullable<T[K]>
    : DeepNonNullableWithPartial<Exclude<T[K], Primitive>>;
};
